Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.HierarchyNavigator

  constructor: (path, full_data, settings = {})->
    @path = path
    @full_data = full_data
    @settings = settings

  extractData: ->
    @data = @limitTags(@search_level(@path, @full_data.levels[0]))

  search_level: (lookingPath, tree) =>
    if @path.length == 0
      return @sortTree(tree)
    if not lookingPath[0] in tree
      return null
    subtree = (tree.filter (x) => x.name == lookingPath[0])[0]
    if subtree == undefined
      return @sortTree(tree)
    if lookingPath.length == 1
      return @sortTree(subtree.children)
    @search_level(lookingPath.slice(1), subtree.children)

  existsPathInTree: () =>
    (@full_data.levels[0].filter (x) => x.name == @path[0])[0] != undefined

  dataIsEmpty: ->
    if @data and @data.length > 0
      sum = 0
      for i in [0...@data.length]
        sum += @data[i].y
      return sum == 0
    return true

  deepInto: (target_name) =>
    target = (@data.filter (x) => x.name == target_name)[0]
    if not @tagInPath(target_name) and target.children and @children_valid(target.children)
      @path.push target_name
      true

  tagInPath: (tag) =>
    @path.indexOf(tag) != -1

  path: ->
    @path

  children_valid: (children) =>
    valid = false
    children.forEach (child) ->
      if child.name and child.name != ""
        valid = true 
    return valid

  onSubpath: (text) =>
    index = @path.indexOf(text)
    if index < (@path.length - 1)
      if index == -1
        @path = []
      else
        @path = @path.slice(0, index+1)
      true

  sortTree: (tree) =>
    if @settings.ordered
      tree.sort (a, b) ->
        parseFloat(b.y) - parseFloat(a.y)
    else 
      tree

  limitTags: (tree) =>
    if @settings.show_limited then tree.slice 0, @settings.tags_limit else tree

  toggleReducedTree: () =>
    @settings.show_limited = !@settings.show_limited
